/** Hostnames allowed for `<img src>` in Content HTML (from app CDN). */
export function getAllowedImageHostsFromCdn(cdn: string): string[] {
  if (!cdn?.trim()) {
    return ['localhost'];
  }

  try {
    const url = cdn.startsWith('http') ? cdn : `https://${cdn}`;
    const host = new URL(url).hostname;
    return host ? [host] : ['localhost'];
  } catch {
    return ['localhost'];
  }
}

/** Base URL for resolving relative links in sanitized Content HTML. */
export function getAppRelativeUrlBase(): string {
  if (typeof window !== 'undefined' && window.location?.origin) {
    return `${window.location.origin}/`;
  }
  return 'http://localhost/';
}
